import './rud.scss';

export const RudTemplate = (model) => {
	const renderMessage = () =>
		/* html */
		`
        <form-input></form-input>
		<otp-button></otp-button>
        <validated-msg></validated-msg>
		${!model.replyInput || model.message.rcv_inp_type_flag === 'date' ? '<confirm-btn></confirm-btn>' : ''}
        <skip-btn></skip-btn>
		<edit-btn></edit-btn>
		`;

	const html = renderMessage();

	return html;
};
